import {
	clearImportProduct,
	confirmImportProducts,
	importProducts,
	importProductsPagination,
	pickStockTable
} from 'actions'
import CommonModal from 'components/common/commonModal'
import NotificationMessage from 'components/common/notificationMessage'
import InputButton from 'components/form/inputButton'
import { ProductImportActions } from 'constants/ActionsTypesTs'
import { addPrevValidations } from 'lib/AxiosInterceptors'
import { validateFileType } from 'lib/Utils'
import {
	IConfirmImportProductsResponse,
	ImportProductError
} from 'models/ProductImport'
import React, { Component, Fragment } from 'react'
import { Button, Col, Container, Row } from 'react-bootstrap'
import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import _ from 'underscore'
import ProductImportTable from './ProductImportTable'
import ProductImportTotals from './ProductImportTotals'
import { IProductImportProps, IProductImportState } from './ProductImportTypes'

const allowedExtensions = [
	'text/csv',
	'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
	'application/vnd.ms-excel',
	'csv'
]

class ProductImport extends Component<
	IProductImportProps,
	IProductImportState
> {
	rfsFile: React.RefObject<any>

	constructor(props: IProductImportProps) {
		super(props)
		this.state = {
			showImportModal: false,
			nameFile: '',
			showError: false,
			errorMessage: '',
			typeError: 'danger',
			pickStockImportData: '',
			fileUpload: null,
			filters: { mostrar: 'T' }
		}
		this.rfsFile = React.createRef()

		addPrevValidations((error: any) =>
			error.request.responseURL.includes('items/impo/importar')
		)
		addPrevValidations((error: any) =>
			error.request.responseURL.includes('items/impo/confirmar')
		)
	}

	componentDidUpdate = (prevProps: Readonly<IProductImportProps>): void => {
		const { confirmedProductsError, importedProductsError, confirmedProducts } =
			this.props

		this.validateProductImportError(
			importedProductsError,
			prevProps.importedProductsError,
			ProductImportActions.IMPORT_PRODUCTS_ERROR
		)

		this.validateProductImportError(
			confirmedProductsError,
			prevProps.confirmedProductsError,
			ProductImportActions.CONFIRM_IMPORT_PRODUCTS_ERROR
		)

		this.validateConfirmedProducts(
			prevProps.confirmedProducts,
			confirmedProducts
		)
	}

	validateConfirmedProducts(
		prevConfirmed: IConfirmImportProductsResponse | null,
		confirmedProducts: IConfirmImportProductsResponse | null
	) {
		if (
			!_.isEqual(prevConfirmed, confirmedProducts) &&
			!_.isEmpty(confirmedProducts)
		) {
			this.handleCloseModal()
		}
	}

	/**
	 *  to validate error in import api
	 * @param impErr
	 * @param prevImpErr
	 * @param errType
	 */
	validateProductImportError = (
		impErr: ImportProductError | null,
		prevImpErr: ImportProductError | null,
		errType: string
	) => {
		if (
			!_.isEqual(impErr, prevImpErr) &&
			!_.isEmpty(impErr) &&
			impErr?.error === errType
		) {
			this.setState({
				showError: true,
				errorMessage: impErr?.messageError
			})
		}
	}

	/**
	 * to close import modal
	 */
	handleCloseModal = () => {
		this.setState({ showImportModal: false, nameFile: '', showError: false })
		this.props.clearImportProduct()
	}

	/**
	 * to open import modal
	 */
	handleOpenModal = () => {
		this.setState({ showImportModal: true })
	}

	/**
	 * when the input file change
	 * @param {event} event
	 */
	handleFileChange = (event: any) => {
		if (!_.isEmpty(event.target.files)) {
			if (validateFileType(event.target.files[0], allowedExtensions)) {
				const fileUpload = event.target.files[0]
				this.setState({
					fileUpload,
					nameFile: fileUpload.name,
					showError: false
				})
			} else {
				this.setState({
					showError: true,
					errorMessage: 'Tipo de archivo incorrecto',
					nameFile: ''
				})
			}
		} else {
			this.setState({ nameFile: '', showError: false })
		}
		this.props.clearImportProduct()
	}

	/**
	 * to call api from import pick stock file.
	 */
	handleImportFile = () => {
		const { idOperacion } = this.props
		const { fileUpload } = this.state
		this.props.importProducts({ idOperacion, archivo: fileUpload })
	}

	/**
	 * to confirm modal
	 */
	handleConfirmForm = () => {
		const { idOperacion } = this.props
		this.props.confirmImportProducts({ idOperacion })
	}

	handleCloseErrorNotification = () => {
		this.setState({ showError: false })
	}

	/**
	 * to handle table pagination
	 */
	handleChangeTable = (type: string, pagination: any) => {
		const { idOperacion } = this.props
		const { filters } = this.state
		const { page, sizePerPage } = pagination

		this.props.importProductsPagination({
			...filters,
			idOperacion,
			page_number: page,
			page_size: sizePerPage
		})
	}

	renderForm = () => {
		const { t, idOperacion, importedProducts } = this.props
		const { nameFile, showError, errorMessage, typeError } = this.state

		return (
			<Container>
				<Row>
					<Col sm={12}>
						<NotificationMessage
							showError={showError}
							errorMessage={errorMessage}
							type={typeError}
							handleCloseError={this.handleCloseErrorNotification}
						/>
					</Col>
					<Col sm={6} className={'pt-2'}>
						<div className="custom-file">
							<input
								id="inputGroupFile01"
								ref={this.rfsFile}
								accept=".csv"
								type="file"
								className="custom-file-input"
								lang="es"
								onChange={this.handleFileChange}
							/>
							<label
								className="custom-file-label"
								data-browse={t('Collection.form.buttons.select')}
								htmlFor="inputGroupFile01"
							>
								{nameFile || t('Collection.import.choose_file')}
							</label>
						</div>
					</Col>
					<Col className={'pt-2'}>
						<InputButton
							valueButton={t('Collection.form.buttons.import')}
							type={'primary'}
							disabled={_.isEmpty(nameFile)}
							onClick={this.handleImportFile}
							customStyle={{ minWidth: '145px' }}
						/>
					</Col>
					<Col className={'pt-2'}>
						<InputButton
							valueButton={t('Collection.form.buttons.accept')}
							type={'primary'}
							onClick={this.handleConfirmForm}
							disabled={_.isEmpty(importedProducts)}
							customStyle={{ minWidth: '145px' }}
						/>
					</Col>
					<Col className={'pr-0 pt-2'}>
						<InputButton
							valueButton={t('Collection.form.buttons.cancel')}
							type={'primary'}
							onClick={this.handleCloseModal}
							customStyle={{ minWidth: '145px' }}
						/>
					</Col>
				</Row>
				<Row>
					<Col sm={12}>
						<ProductImportTotals
							totals={importedProducts}
							handleChangeFilter={(data: any) => {
								this.props.importProductsPagination({
									...data,
									idOperacion,
									page_size: 10,
									page_number: 1
								})

								this.setState({ filters: data })
							}}
						/>
					</Col>
				</Row>
				<Row>
					<ProductImportTable
						pickStockData={importedProducts}
						idOperacion={idOperacion}
						handleChangeTable={this.handleChangeTable}
					/>
				</Row>
			</Container>
		)
	}

	render() {
		const { t, minWidth } = this.props
		const { showImportModal } = this.state

		const modalProps = {
			sizeModal: 'xl',
			customClass: 'theme.size_modal',
			showModal: showImportModal,
			handleCloseModal: this.handleCloseModal,
			modalTitle: t('Collection.form.buttons.import'),
			modalBody: this.renderForm()
		}

		return (
			<Fragment>
				<Button
					style={{ minWidth: minWidth || '125px' }}
					type={'button'}
					onClick={this.handleOpenModal}
				>
					{t('Collection.form.buttons.import')}
				</Button>
				{showImportModal && <CommonModal {...modalProps} />}
			</Fragment>
		)
	}
}

const mapStateToProps = ({ productImport }: any) => {
	const {
		importedProducts,
		importedProductsError,
		confirmedProductsError,
		confirmedProducts
	} = productImport

	return {
		importedProducts,
		importedProductsError,
		confirmedProductsError,
		confirmedProducts
	}
}

const mapDispatchToProps = {
	pickStockTable,
	importProducts,
	confirmImportProducts,
	importProductsPagination,
	clearImportProduct
}

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(withTranslation()(ProductImport))
